import { mapState } from 'vuex';
import * as profileTypes from '@/store/modules/profile/mutation-types';

export default {
  data: () => ({
    updatedProfileMap: {},
  }),

  computed: {
    ...mapState('profile', ['selectedProfile', 'profileDialogVisible']),
  },

  methods: {
    getProfileId(profile) {
      // eslint-disable-next-line
      if (profile._id) return profile._id.$oid || profile._id;
      return profile.id;
    },

    handleProfileUpdated(profile) {
      this.$set(this.updatedProfileMap, profile.id, profile);
    },

    handleProfileDialogVisibilityChanged(value) {
      if (!value) {
        this.$store.commit(`profile/${profileTypes.SELECT_PROFILES_PROFILE}`, null);
      }
      this.$store.commit(`profile/${profileTypes.SHOW_PROFILES_DIALOG}`, value);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/profile/ProfileDialogMixin.js